import React, { useEffect } from "react";
import { DateAndTimeGridCell } from "../common/DateAndTimeGridCell";
import StatusActiveInactive from "../common/StatusActiveInactive";
import  {CONTRACT_ACTION_TYPE, CONTRACT_STATUS_TYPE } from "../../services/Constants";
import { TextField } from "@mui/material";



const ContractActionInput = (props) => {
  return (
    <>
      <TextField
        label="Value"
        variant="standard"
        style={{ minWidth: 120 }}
        select
        SelectProps={{
          native: true,
        }}
        value={props.item.value || ""}
        onChange={(event) =>
          props.applyValue({ ...props.item, value: event.target.value })
        }
      >
        <option value="" disabled>
          -- Select Action --
        </option>
        {
          Object.entries(CONTRACT_ACTION_TYPE).map(([key, value]) => (
          <option key={key} value={value}>
            {value}
          </option>
        ))}
      </TextField>
    </>
  );
};

const ContractStatusTypeInput = (props) => {
  return (
    <>
      <TextField
        label="Value"
        variant="standard"
        style={{ minWidth: 120 }}
        select
        InputLabelProps={{
          shrink: true,  
        }}
        value={props.item.value || ""}
        SelectProps={{
          native: true,
        }}
        onChange={(event) =>
          props.applyValue({ ...props.item, value: event.target.value })
        }
      >
         <option value="" disabled>
           Select Status 
        </option>
        {
          Object.entries(CONTRACT_STATUS_TYPE).map(([key, value]) => (
          <option key={key} value={value}>
            {value}
          </option>
        ))}
      </TextField>
    </>
  );
};


const getServiceContractAuditCols = () => {
  const customFilterOperatorForContractActionType = [
    {
      value: "equals",
      label: "Equals",
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.field || !filterItem.value || !filterItem.operator) {
          return null;
        }
        return (params) => {
          return params.value.toLowerCase() === filterItem.value.toLowerCase();
        };
      },
      InputComponent: ContractActionInput,
      InputComponentProps: { type: "string" },
    },
    // Add more custom operators as needed
  ];

  const customFilterOperatorsForStatusType = [
    {
      value: "equals",
      label: "Equals",
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.field || !filterItem.value || !filterItem.operator) {
          return null;
        }
        return (params) => {
          return params.value.toLowerCase() === filterItem.value.toLowerCase();
        };
      },
      InputComponent: ContractStatusTypeInput,
      InputComponentProps: { type: "string" },
    },
    // Add more custom operators as needed
  ];
  return [
    {
      field: "vehicleKey",
      headerName: "Vehicle Key",
      flex: 1,
    },
    {
      field: "contractAction",
      headerName: "Contract Action",
      filterable: false,
      // filterOperators: customFilterOperatorForContractActionType,
      flex: 0.75,
      renderCell: ({ row }) => CONTRACT_ACTION_TYPE[row.contractAction] || "—"
    },
    {
      field: "telematicsContractStatus",
      headerName: "Telematics Contract",
      type: "enum",
      filterOperators: customFilterOperatorsForStatusType,
      flex: 0.5,
      renderCell: ({ row }) => {
        return <StatusActiveInactive active={row?.telematicsContractStatus === "VALID"} />;
      },
    },
       
    {
      field: "routingServerContractStatus",
      headerName: "Routing Server Contract",
      type: "enum",
      flex: 0.5,
      filterOperators: customFilterOperatorsForStatusType,
      renderCell: ({ row }) => {
        return <StatusActiveInactive active={row?.routingServerContractStatus === "VALID"} />;
      },
    },
    {
      field: "createdAt",
      headerName: "Updated Date",
      type: "dateTime",
      filterable: false,
      flex: 0.75,
      renderCell: (d) => <DateAndTimeGridCell value={d.value} />,
    },
    
  ];
};


const getColumnsData = () => {
  return getServiceContractAuditCols();
};
export { getColumnsData };
